$(function () {
    // Preload images
    //let imageRoot = '/static/img/';
    //let images = new Array("elektro-1.jpg", "elektro-2.jpg", "vvs-1.jpg", "vvs-2.jpg", "sjekkliste-digital.jpg", "sjekkliste-excel.jpg", "sjekkliste-rapport.jpg", "kalender-outlook.jpg", "kalender-sc.jpg");
    //function preloadImages() {
    //    images.forEach(image => {
    //        let tmpImage = new Image();
    //        tmpImage.src = `${imageRoot}${image}`;
    //    });
    //}
    //preloadImages();

    // Det ble prakk i Google Chrome om threshold var 1.0 entry.intersectionRatio == 1.0
    // entry.intersectionRatio var 0.9999995827674866 i stedet for 1.0

    let options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.95
    }
    function callback(entries, observer) {
        //console.dir(entries);
        entries.forEach(entry => {
            if (entry.intersectionRatio > 0.95) {
                entry.target.classList.add("sc-anim-end");
                observer.unobserve(entry.target);
            }
        });
    }
    let observer = new IntersectionObserver(callback, options);
    let target = document.querySelectorAll('.sc-anim-entry');

    target.forEach(elm => observer.observe(elm));

    function fetchCompanyData() {
        // Tester henting av data fra BRREG
        let orgno = "931515829";
        fetch(`https://data.brreg.no/enhetsregisteret/api/enheter/${orgno}`)
            .then(response => {
                let responseStatusCode = response.status;   // Denne er tallet 200 hvis alt er ok
                // brreg gir status 400 hvsi feil antall tall (skal være 9). De gir status 404 hvis enheten ikke finnes i registeret (eller kanskje nummeret er feil oppbygd?)
                console.log("Response:");
                console.dir(response);
                if (!response.ok) {
                    return null;
                }
                let type = response.headers.get("content-type");
                if (type !== "application/json") {
                    throw new TypeError(`Expected JSON, got ${type}`);
                }
                return response.json();
            })
            .then(data => {
                if (data) {
                    console.log("Data:");
                    console.dir(data);
                } else {
                    // If we get 404 or similar error above and returned null we end up here
                    console.log("Ukjent organisasjonsnummer");
                }
            })
            .catch(e => {
                //if (e instanceof NetworkError) {    // Internet connection is down (Får feilmelding, finner ikke NetworkError på Mozilla?)
                //    alert("Network down");
                //}
                //else if (e instanceof TypeError) {  // We come here if we throw TypeError above
                //    alert("Type error");
                //}
                //else {
                //    alert("Unanticipated error");
                //}
                console.dir(e);
            });
    }
});